import {
  createAdministrationMarketplaceAllowancePolicy,
  fetchAdministrationMarketplaceAllowancePolicies,
} from "../../../api/administrationMarketplace";
import { createResourceLoader } from "../../state/keyedResourceLoader";
import type {
  MarketplaceAdministrationSlice,
  MarketplaceAllowancePolicySlice,
} from "./types";

const loader = createResourceLoader();

export const marketplaceAllowancePolicyInitialState = {
  allowancePolicies: [],
  allowancePoliciesHydrated: false,
  allowancePoliciesLoading: false,
  allowancePoliciesError: "",
  allowancePolicyMutationLoading: false,
};

export const resetMarketplaceAllowancePolicyRequests = loader.clear;

export const createMarketplaceAllowancePolicySlice:
  MarketplaceAdministrationSlice<MarketplaceAllowancePolicySlice> = (set, get) => ({
    ...marketplaceAllowancePolicyInitialState,
    loadAllowancePolicies: (force = false) => loader.load({
      force,
      cached: get().allowancePoliciesHydrated,
      request: fetchAdministrationMarketplaceAllowancePolicies,
      onStart: () => set({ allowancePoliciesLoading: true, allowancePoliciesError: "" }),
      onSuccess: (allowancePolicies) => set({ allowancePolicies, allowancePoliciesHydrated: true }),
      onError: (allowancePoliciesError) => set({ allowancePoliciesError }),
      onFinish: () => set({ allowancePoliciesLoading: false }),
      errorMessage: "Unable to load Marketplace allowance policies.",
    }),
    createAllowancePolicy: async (configuration) => {
      if (get().allowancePolicyMutationLoading) {
        throw new Error("An allowance policy change is already in progress.");
      }
      set({ allowancePolicyMutationLoading: true });
      try {
        const policy = await createAdministrationMarketplaceAllowancePolicy(configuration);
        await Promise.all([
          get().loadAllowancePolicies(true),
          ...(get().productsHydrated ? [get().loadProducts(true)] : []),
          ...(get().overviewHydrated ? [get().loadOverview(true)] : []),
        ]);
        return policy;
      } finally {
        set({ allowancePolicyMutationLoading: false });
      }
    },
  });
